import React from 'react';
import { useLocation } from 'react-router-dom';

function MarqueeLine({ ariaHidden, light }) {
  const muted = light ? 'text-stone-500' : 'text-zinc-400';
  const accent = light ? 'text-[#2c5f54]' : 'text-[#9fd4c9]';
  return (
    <span
      className="inline-flex shrink-0 items-center whitespace-nowrap px-8 font-mono text-[10px] sm:text-xs uppercase tracking-widest"
      aria-hidden={ariaHidden ? true : undefined}
    >
      <span className={muted}>First order on SprintFit? Use code </span>
      <span className={`${accent} font-semibold`}>WELCOME500</span>
      <span className={muted}> — flat </span>
      <span className={`${accent} font-semibold`}>{'\u20B9'}500</span>
      <span className={muted}> off at checkout. First-time customers only, any product.</span>
      <span className="inline-block w-12 shrink-0" aria-hidden />
    </span>
  );
}

export function PromoTicker() {
  const { pathname } = useLocation();
  const light = pathname === '/';

  return (
    <div
      role="region"
      aria-label="Promotional announcement"
      className={`fixed top-0 left-0 right-0 z-[60] h-9 backdrop-blur-md border-b ${
        light
          ? 'border-stone-200/90 bg-[#ebe8e2]/95'
          : 'border-white/[0.06] bg-[#0a0a0b]/95'
      }`}
    >
      <p className="sr-only">
        First-time customers: use coupon code WELCOME500 at checkout for flat five hundred rupees off on any SprintFit product.
      </p>

      <div className="motion-reduce:flex hidden h-full items-center justify-center px-3">
        <p
          className={`font-mono text-[10px] sm:text-xs uppercase tracking-widest text-center truncate max-w-[100vw] ${
            light ? 'text-stone-500' : 'text-zinc-400'
          }`}
          aria-hidden
        >
          First order? Use{' '}
          <span className={`font-semibold ${light ? 'text-[#2c5f54]' : 'text-[#9fd4c9]'}`}>WELCOME500</span> — flat
          ₹500 off — first-time customers, any product
        </p>
      </div>

      <div className="motion-reduce:hidden h-full overflow-hidden flex items-center" aria-hidden>
        <div className="flex w-max animate-promo-marquee motion-reduce:animate-none">
          <MarqueeLine light={light} />
          <MarqueeLine ariaHidden light={light} />
        </div>
      </div>
    </div>
  );
}
